export let currentMode = null;

export const pdfStyles = {
  page: {
    paddingTop: 0,
    paddingBottom: 66,
    paddingHorizontal: 0,
    alignItems: "flex-start",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    backgroundColor: "#ffffff",
  },
}

export const feedingGuidelinesMode = {
  "maintenance": {
    "components": [
      {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "50%",
          backgroundColor: "#ffffff",

        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-body-condition",
        styles: {
          width: "50%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      /*{
        key: "fc-screenshot-feeding-guidelines-personalized-nutrient-profile",
        styles: {
          width: "100%",
          border: 6,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
          maxWidth: "100%",
        },
        fixed: false,
      },*/
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },

  "weight_adjustment": {
    "components": [
      {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "50%",
          backgroundColor: "#ffffff",

        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-body-condition",
        styles: {
          width: "50%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-line-chart",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-recommended",
        styles: {
          width: "100%",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-food-intake",
        styles: {
          width: "100%",
        },
        fixed: false,
      },
      /*{
        key: "fc-screenshot-feeding-guidelines-personalized-nutrient-profile",
        styles: {
          width: "50%",
          border: 6,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },*/
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },

  "growth": {
    "components": [
      {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "100%",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-recommended",
        styles: {
          width: "100%",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },

  "lactation": {
    "components": [
       {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-recommended",
        styles: {
          width: "100%",
        },
        fixed: false,
      },/*
      {
        key:  "fc-screenshot-feeding-guidelines-personalized-nutrient-profile",
        styles: {
          width: "100%",
        },
        fixed: false,
      },*/
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },

  "pregnancy": {
    "components": [
       {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "100%",
          backgroundColor: "#ffffff",

        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-recommended",
        styles: {
          width: "100%",
        },
        fixed: false,
      },/*
      {
        key:  "fc-screenshot-feeding-guidelines-personalized-nutrient-profile",
        styles: {
          width: "100%",
        },
        fixed: false,
      },*/
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },

  "weightLoss": {
    "components": [
       {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "50%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-body-condition",
        styles: {
          width: "50%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
     {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      /*
      {
        key: "fc-screenshot-feeding-guidelines-line-chart",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: false,
      },

      {
        key: "fc-screenshot-feeding-guidelines-personalized-nutrient-profile",
        styles: {
          width: "100%",
          border: 6,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },*/
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },

  "hospitalisation": {
    "components": [
       {
        key: "fc-screenshot-feeding-guidelines-header",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
      {
        key: "fc-screenshot-feeding-guidelines-intro",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#f4f6f8",
          border: 1,
          borderStyle: "solid",
          borderColor: "#f4f6f8",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-products",
        styles: {
          width: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
     {
        key: "fc-screenshot-feeding-guidelines-notes",
        styles: {
          width: "100%",
          objecFit: "fill",
          maxWidth: "100%",
          backgroundColor: "#ffffff",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-recommended",
        styles: {
          width: "100%",
        },
        fixed: false,
      },
      {
        key: "fc-screenshot-feeding-guidelines-food-intake",
        styles: {
          width: "100%",
        },
        fixed: false,
      },/*
      {
        key: "fc-screenshot-feeding-guidelines-personalized-nutrient-profile",
        styles: {
          width: "100%",
        },
        fixed: false,
      },*/
      {
        key: "fc-screenshot-feeding-guidelines-disclaimer",
        styles: {
          width: "100%",
          position: 'absolute',
          bottom: 0,
          left: 0,
          objecFit: "fill",
          maxWidth: "100%",
        },
        fixed: true,
      },
    ],
  },
};

export const getCurrentMode = () => {
  return currentMode;
}

export const setCurrentMode = (mode) => {
  currentMode = mode;
}
